module.exports = {"650121100":"水西沟镇","650121102":"板房沟镇","650121207":"萨尔达坂乡","650121208":"甘沟乡","650121210":"永丰乡","650121213":"托里乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650121.json
// module id = 2841
// module chunks = 0